// component specific constant
export const defaultPrecision: number = 2;
export enum InputTextAlignment {
	left,
	right,
}
